<figure class="a-image" *ngIf="image.source && image.source.s">
	<picture class="a-image__picture"
			 *ngIf="image.source.m">
		<source *ngIf="image.source.l" [attr.data-srcset]="image.source.l" media="(min-width: 1025px)" />
		<source *ngIf="image.source.m" [attr.data-srcset]="image.source.l" media="(min-width: 650px)" />
		<img class="a-image__img lazyload" [alt]="image.alt" [attr.data-srcset]="image.source.s" [src]="image.source.s"/>
		<noscript>
			<img class="a-image__img" [alt]="image.alt" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" [attr.data-src]="image.source.s"/>
		</noscript>
	</picture>
	<img *ngIf="!image.source.m" class="a-image__img lazyload" [alt]="image.alt" [attr.data-srcset]="image.source.s" [src]="image.source.s"/>
</figure>
